import { render } from "./textBox.vue?vue&type=template&id=2271c60f"
import script from "./textBox.vue?vue&type=script&lang=js"
export * from "./textBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__